import { createContext, memo, ReactNode, useContext } from "react";
import { Placement } from "@floating-ui/react";

export type AppNavigationState = {
  type: "header" | "mobile" | "sidebar",
  isMinimized: boolean,
  isExpanded: boolean,
  isOpen: boolean,
  menuItemMinimized: boolean,
  showTooltip?: boolean,
  tooltipPlacement?: Placement,
}

export const AppNavigationStateContext = createContext<AppNavigationState>({
  type: "sidebar",
  isMinimized: false,
  isExpanded: false,
  isOpen: false,
  menuItemMinimized: false,
  showTooltip: false,
});

export const useAppNavigationStateContext = () => useContext(AppNavigationStateContext);

export const AppNavigationStateContextProvider = memo<{ value?: Partial<AppNavigationState> | null, children: ReactNode }>(
  (
    {
      value,
      children,
    },
  ) => {
    return <AppNavigationStateContext.Consumer>
      {
        external => {
          return <AppNavigationStateContext.Provider value={{
            ...external,
            ...Object.entries(value || {})
              .filter(([ key, value ]) => value !== undefined)
              .reduce((acc, [ key, value ]) => ({ ...acc, [key]: value }), {}),
            menuItemMinimized: external.menuItemMinimized || value?.menuItemMinimized || false,
            showTooltip: external.showTooltip || value?.showTooltip || false,
          }}>
            {children}
          </AppNavigationStateContext.Provider>;
        }
      }
    </AppNavigationStateContext.Consumer>;
  },
);